module.exports = __webpack_public_path__ + "static/media/google-circle.9600a046.svg";